import { useState } from 'react';
export function Information(props) {
  const [infoVisible, setInfoVisible] = useState(false);

  const toggleInfo = () => {
    setInfoVisible((infoVisible) => !infoVisible);
  };

  return (
    <aside className={`info-box ${infoVisible ? 'show' : 'hide'}`}>
      <div className="info-contents">
        <h2>Information on grid interaction patterns:</h2>
        <dl>
          <dt>Adding blocks:</dt>
          <dd>
            New blocks can be added as long as there is room to accomodate them.
            A newly added block will be{' '}
            <b>inserted before the block occupying the upper left position,</b>{' '}
            pushing all blocks over to the right.
          </dd>
          <dt>Repositioning blocks:</dt>
          <dd>
            Blocks can be grabbed and dragged to any of the eight regions of the
            grid. A moved block will{' '}
            <b>push all subsequent blocks further down the grid,</b> first
            towards the right, then wrapping onto the bottom row.
          </dd>
          <dt>Deleting blocks:</dt>
          <dd>
            Any visible block can be deleted. Upon deletion,{' '}
            <b>
              the block occupying the same column as the deleted one will extend
              to two rows.
            </b>{' '}
            No other reflow will occur.
          </dd>
          <dt>Extended blocks:</dt>
          <dd>
            Extended blocks follow different repositioning rules than single
            blocks. When dragged directly,{' '}
            <b>extended blocks "carry" their deleted block with them,</b>{' '}
            allowing them to retain their double height. As a result, they can
            only occupy the top row.{' '}
          </dd>
          <dd>
            When respositioned by a single-blog drag,{' '}
            <b>
              extended blocks will move rightward like normal blocks until they
              reach the rightmost column.
            </b>{' '}
            At that point, single blocks will wrap inside the remaining space.
          </dd>
          <dd>
            <b>
              The interaction pattern for dragging a single block onto an
              extended block is still being determined.
            </b>{' '}
            Currently, when dragged upon, the extended block will simply slide
            out of the way. But two other interaction patterns are being
            considered: one that collapses and pairs the two blocks, and one
            that swaps the two blocks.
          </dd>
          <dt>Edge cases and bugs:</dt>
          <dd>
            Once four extended blocks fill the grid, deleting one of them will
            leave two empty blocks.{' '}
            <b>
              It is not possible to determine the column count from the number
              of remaining blocks.
            </b>{' '}
            Block counts of four, five or six are valid inside either a four-column or
            three-column grid. Block counts of two, three or four are valid inside either
            a two-column or three-column grid.
          </dd>
        </dl>
      </div>
      <nav className="button-bar">
        <button className="toggle-info" onClick={toggleInfo}>
          {infoVisible ? 'Hide' : 'Show'} information
        </button>
      </nav>
    </aside>
  );
}
